import { PenDimensionPipePlacementEnum } from './PenDimensionPipe';

export class PenDimensionPipeSegment {
  Id: number;
  PenId: number;
  CustomerName: string;
  PorjectName: string;
  Placement: PenDimensionPipePlacementEnum;
  Dimension: number;
  PipeSize: number;
  SDR: number;
  PenDimensionPipeId: number;
  Index: number;
  WeldToPenDimensionPipeSegmentIndex: number;
  WeldNo: number;
  HasBulkHead: boolean;
  BulkHeadWeldNo: number;
  WeldTemp: number;
  PlateTempMeasured: number;
  JoiningPressure: number;
  DragPressure: number;
  TotalFusionPressure: number;
  HeatingTimeWithPressure: number;
  HeatingTimeWithoutPressure: number;
  ChangeOverTime: number;
  CoolDownTimeWithPressure: number;
  BeadWidth: number;
  Note: string;
  PenDimensionPipeSegmentStatusId: number;
  Date: Date;
  WelderUserId: string;
  BatchNr: string;
  BulkHeadStatusType: BulkHeadStatusType;
  WeldingMachineId: number;
  WeatherConditionType: WeatherConditionType;
  WeatherTemperatur: number;
}

export class UpdatePenDimensionPipeSegment {
  Index: number;
  WeldNo: number;
  HasBulkHead: boolean;
  BulkHeadWeldNo: number;
  WeldTemp: number;
  PlateTempMeasured: number;
  JoiningPressure: number;
  DragPressure: number;
  TotalFusionPressure: number;
  HeatingTimeWithPressure: number;
  HeatingTimeWithoutPressure: number;
  ChangeOverTime: number;
  CoolDownTimeWithPressure: number;
  BeadWidth: number;
  Note: string;
  PenDimensionPipeSegmentStatusId: number;
  Date: Date;
  WelderUserId: string;
  BatchNr: string;
  BulkHeadStatusType: BulkHeadStatusType;
  WeldingMachineId: number;
  WeatherConditionType: WeatherConditionType;
  WeatherTemperatur: number;
}

export enum BulkHeadStatusType {
  NoBulkHead = 0, //No, no bulk head
  YesPreWeldedBulkHead = 1, //Yes, pre welded bulk head
  YesExtrusionWeldedBulkHead = 2, // Yes, extrusion welded bulkhead
}

export enum WeatherConditionType {
  Sun = 0, // Sol
  Cloudy = 1, // Overskyet
  RainSnow = 2, //Regn/snø
}
